import React, { useRef } from "react"
import { api } from "apiServer"
import { Layout } from "components/common"
import SwiperVideo from "components/SwiperVideo"
import { useEffect, useState } from "react"
import CardHorizontal from "components/TypeCard/CardHorizontal"
import { getAccessToken } from "lib/Cookies"
import axios from "axios"
import { notification } from "components/ui"

const PAGE_SIZE = 24
const PAGE_NUM = 1
function Component({ league, id }) {
  const [isFollowing, setIsFollowing] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [scroll, setScroll] = useState(false)

  const [pageNum, setPageNum] = useState(PAGE_NUM)
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const loaderRef = useRef(null)

  const fetchData = async () => {
    setLoading(true)
    try {
      const { data } = await api.getVideoOfLeague(getAccessToken(), {
        league_id: id,
        page_num: pageNum,
        page_size: PAGE_SIZE
      })
      const newItems = data?.video || []
      setItems((prev) => [...prev, ...newItems])

      if (newItems < PAGE_SIZE) {
        setHasMore(false)
      }
    } catch (err) {
      console.error("Lỗi:", err)
      setHasMore(false)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (hasMore && pageNum !== PAGE_NUM) {
      fetchData()
    }
  }, [pageNum])

  useEffect(() => {
    if (!hasMore) return

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !loading) {
        setPageNum((prev) => prev + 1)
      }
    })

    const loader = loaderRef.current
    if (loader) observer.observe(loader)

    return () => {
      if (loader) observer.unobserve(loader)
    }
  }, [loading, hasMore])

  useEffect(() => {
    fetchData()
  }, [id])

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1025) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const wapperSlide = document.querySelector(".wapper__slide")
      const wapperSlideHeight = wapperSlide ? wapperSlide.offsetHeight : 0
      if (window.scrollY > wapperSlideHeight) {
        setScroll(true)
      } else {
        setScroll(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  useEffect(() => {
    async function fetchInitialFollowing() {
      const token = getAccessToken()
      if (!token) return

      try {
        const response = await axios.get(`${process.env.NEXT_PUBLIC_FOLLOW}/api/following/get-list-status-following`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })

        if (response.status === 200) {
          const list = response.data.data
          const isFollowed = list.some((item) => item.id === id)
          setIsFollowing(isFollowed)
        }
      } catch (error) {
        notification.error({
          message: "Lỗi khi gọi API:" + error.response?.data || error.message
        })
        return []
      }
    }

    fetchInitialFollowing()
  }, [id])

  const handleFollow = async () => {
    const token = getAccessToken()
    if (!token) {
      notification.warning({
        message: "Vui lòng đăng nhập để thực hiện hành động này!"
      })
      return
    }

    try {
      if (isFollowing) {
        notification.warning({
          message: "Bạn đã theo dõi Giải đấu này!"
        })
      } else {
        const response = await axios.post(
          `${process.env.NEXT_PUBLIC_FOLLOW}/api/league/update-wishlist`,
          { favorite_leagues: [id] },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        )
        if (response.status === 200) {
          notification.success({
            message: "Theo dõi Giải đấu thành công!"
          })
          setIsFollowing(true)
        }
      }
    } catch (error) {
      notification.error({
        message: "Có lỗi xảy ra. Vui lòng thử lại!"
      })
    }
  }

  let isDragging = false
  let startX

  function handleDragStart(e) {
    e.preventDefault()
    isDragging = true
    startX = e.pageX || e.touches[0].pageX
  }

  function handleDrag(e) {
    if (!isDragging) return
    const x = e.pageX || e.touches[0].pageX
    const scrollLeft = e.currentTarget.scrollLeft
    e.currentTarget.scrollLeft = scrollLeft - (x - startX)
    startX = x
  }

  function handleDragEnd() {
    isDragging = false
  }

  return (
    <section className="mb-[46px] 3xl:ml-0 max-sm:mr-0 max-sm:ml-0 max-lg:mr-4 max-lg:ml-4 xl:mr-8 md:mx-4">
      <div
        className={`wapper__slide ${isMobile ? "draggable sticky top-[58.75px] z-30 bg-[#131313]" : ""}`}
        onMouseDown={(e) => handleDragStart(e)}
        onMouseMove={(e) => handleDrag(e)}
        onMouseUp={() => handleDragEnd()}
        onMouseLeave={() => handleDragEnd()}
      >
        <MyImage
          name={league?.name}
          thumbnail={league?.thumbnail}
          description={league?.descriptions}
          backgroundColor={league?.background_color}
          isFollowing={isFollowing}
          handleFollow={handleFollow}
          isMobile={isMobile}
          scroll={scroll}
        />
      </div>

      <div className="mx-auto overflow-x-hidden mt-8 max-sm:px-4">
        {league?.event?.length > 0 && (
          <SwiperVideo
            name={"Sự kiện"}
            videos={[...league.event].sort((a, b) => (b.status === "live") - (a.status === "live"))}
            type_block={1}
          />
        )}
        {items?.length > 0 && (
          <div className="flex flex-col gap-3.5">
            <span className="text-[24px] leading-[30px] text-white font-semibold max-sm:text-[16px]">Video</span>
            <div className={"grid grid-cols-4 gap-6 max-sm:grid-cols-1 max-lg:grid-cols-3 max-lg:gap-3"}>
              {items?.length > 0 &&
                items?.map((item) => {
                  const { id, type } = item
                  return (
                    <CardHorizontal
                      {...item}
                      display_type={0}
                      showTime={false}
                      key={id}
                      nextLink={`/video?id=${id}&type=${type}`}
                      customGrid={true}
                    />
                  )
                })}
            </div>
          </div>
        )}

        {hasMore && (
          <div ref={loaderRef} className="h-10 text-center text-sm text-gray-500">
            {loading ? "Đang tải dữ liệu..." : ""}
          </div>
        )}

        {!league?.event && !items && (
          <div className="flex flex-col gap-2 items-center justify-center py-[193px] text-center">
            <span className="text-[22px] leading-[30px] font-semibold text-white">Nội dung chưa sẵn sàng</span>
            <span className="text-base leading-5 font-normal text-[#c6c6c8]">
              Chúng tôi đang cập nhật nội dung này. Bạn có thể thử lại sau một thời gian nữa.
            </span>
          </div>
        )}
      </div>
    </section>
  )
}
export default Component
Component.Layout = Layout

function renderUrl(base_url, thumbnail, size) {
  if (thumbnail?.includes("http")) return thumbnail
  if (!thumbnail) return "/placeholder_video.svg"
  return `${base_url}${size}/${thumbnail}`
}

function MyImage({
  base_url,
  thumbnail,
  name,
  description,
  backgroundColor,
  handleFollow,
  isFollowing,
  isMobile,
  scroll
}) {
  return (
    <div className="relative rounded-3xl overflow-hidden max-sm:rounded-none">
      {isMobile && scroll ? (
        <></>
      ) : (
        <div
          className="w-full h-[72px] absolute bottom-0 left-0"
          style={{
            background: `linear-gradient(180deg, transparent 0%, ${backgroundColor} 84.66%, ${backgroundColor} 100%)`
          }}
        ></div>
      )}

      <div
        className={`bottom-0 left-0 w-full flex items-center justify-between px-5 pb-5 max-sm:pb-3 max-sm:px-3 ${
          isMobile && scroll ? "pt-4 pb-4" : "absolute "
        }`}
      >
        <div className="flex flex-col w-full gap-1">
          <div className="font-semibold text-2xl text-[#fafaf9] max-sm:line-clamp-2">{name}</div>
          <div className="font-normal text-sm text-secondary line-clamp-1 max-sm:hidden">{description}</div>
        </div>
        <button className="cursor-pointer" onClick={handleFollow}>
          {isFollowing ? (
            <img src={isMobile && scroll ? "/icons/iconBtnFollowed-mobile.png" : "/icons/iconBtnFollowed.svg"} />
          ) : (
            <img src={isMobile && scroll ? "/icons/iconBtnFollow-mobile.png" : "/icons/iconBtnFollow.svg"} />
          )}
        </button>
      </div>
      {isMobile && scroll ? (
        <></>
      ) : (
        <div className="fix_img">
          <img
            placeholder="blur"
            className="w-full rounded-3xl h-[358px] object-cover max-sm:rounded-none"
            src={renderUrl(base_url, thumbnail, "1920x800") || "/placeholder_banner.svg"}
            width={1578}
            height={358}
            alt={name}
          />
        </div>
      )}
    </div>
  )
}

export async function getServerSideProps({ req, query, res }) {
  res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=29")
  let league = {}

  const { cookies } = req
  const { id } = query

  try {
    const { data } = await api.getVideoOfLeague(cookies?.accessToken, {
      league_id: id,
      page_num: PAGE_NUM,
      page_size: PAGE_SIZE
    })

    league = data ? data : {}
  } catch (error) {
    // console.log(error.response)
  }

  return { props: { league, id } }
}
